import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBudget } from "../../../../../controller/services/settings";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import { formatNumber } from "../../../../../utils/helper";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";
import dayjs from "dayjs";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/hi";

const MyBudgets = () => {
  const [budgets, setBudgets] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (i18n.language === "fr") {
      dayjs.locale("fr")
    } else if (i18n.language === "es") {
      dayjs.locale("es")
    } else if (i18n.language === "hi") {
      dayjs.locale("hi")
    }
  }, [i18n.language]);
  useEffect(() => {
    getBudgets();
  }, []);

  const getBudgets = () => {
    dispatch(setLoading(true));
    getBudget()
      .then((resp) => {
        setBudgets(resp?.data);
      })
      .catch((err) => {
        message.error(err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const convertMonthToWord = (month) =>
    dayjs(month, "MM-YYYY").format("MMMM YYYY");

  const budgetClickHandler = (budget) => {
    navigate(`/budget/${budget?._id}`, {
      state: {
        budgetData: budget,
      },
    });
  };

  return (
    <RightSideSettingsWrapper>
      {budgets?.length > 0 ? (
        budgets?.map((budget) => (
          <div
            className="row mx-0 details-common-card-row"
            key={budget?._id}
            onClick={() => budgetClickHandler(budget)}
            style={{ cursor: "pointer" }}
          >
            <div className="col-12">
              <h5 className="d-flex small-size-title align-items-center justify-content-between">
                {budget?.title}
                <div className="title-date-div">
                  {convertMonthToWord(budget?.currentMonth)}
                </div>
              </h5>
              <div className="row">
                <div className="col-11 budget-list-primary-settings">
                  <ul className="list-inline d-flex align-items-center justify-content-between">
                    <li style={{ color: "#2fa83b" }}>
                      {t("commonStepper.section2")}
                    </li>
                    <li style={{ color: "#2fa83b" }}>
                      $ {formatNumber(Number(budget?.totalIncome)?.toFixed(2))}
                    </li>
                  </ul>
                  <ul className="list-inline d-flex align-items-center justify-content-between">
                    <li>{t("commonStepper.section3")}</li>
                    <li>
                      $ {formatNumber(Number(budget?.totalExpense)?.toFixed(2))}
                    </li>
                  </ul>
                </div>
                <div className="col-1">
                  <h3>{">"}</h3>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="row details-common-card-row d-flex justify-content-center align-items-center h-100 p-3">
          <div className="no-data-screen text-center">
            {t("settings.noBudgets")}
          </div>
        </div>
      )}
    </RightSideSettingsWrapper>
  );
};

export default MyBudgets;
